import { Button } from '@material-ui/core'
import { editSolution, setAdminUncsModalState, setSolutionObj } from '@root-gipro/modules/AdminPanel/store/actions'
import { showNotify } from '@root-gipro/modules/notify/store/actions'
import { SelectTableHeader } from '@root-gipro/modules/userProjects/components/Project/UncAdd/SelectTableHeader'
import { SelectTableTbody } from '@root-gipro/modules/userProjects/components/Project/UncAdd/SelectTableTbody'
import { SelectTableThead } from '@root-gipro/modules/userProjects/components/Project/UncAdd/SelectTableThead'
import { tbodyArr } from '@root-gipro/modules/userProjects/models/consts/unc-tbody.const'
import { ISelectTableProps } from '@root-gipro/modules/userProjects/models/interfaces/project-unc-add.props'
import {
	addUnc,
	changeUncCheckedTable,
	createSpecialUnc,
	fetchUncTableData,
	selectTableElem,
} from '@root-gipro/modules/userProjects/store/actions'
import { IState } from '@root-gipro/store/interfaces/state'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const blockedWithAutoAddUncIds = [231, 315, 316, 317, 318, 319, 320]

export const SelectTable: React.FC<ISelectTableProps> = ({ setShowDirections, solutionCase }) => {
	const { selectedElem, uncTableData, interpolation, originalObj, uncCheckedTable, projectObj } = useSelector(
		(state: IState) => state.userProjects
	)
	const { isAdminUncsModalState, solutionObj } = useSelector((state: IState) => state.adminPanel)

	const dispatch = useDispatch()
	const [checkedTable, setChecked] = useState('1')
	const [showInter, setShowInter] = useState(false)
	const tableNums: string[] = tbodyArr.filter(item => item.sitePreparation).map(item => String(item.tableNum))
	const [blockAddUnc, setBlockAddUnc] = useState(false)
	const tableTitles: any[] = tbodyArr
		.filter(item => item.sitePreparation)
		.map(item => ({ title: item.titleShort, tableNum: String(item.tableNum) }))

	useEffect(() => {
		if (selectedElem) {
			const blockedUncTable = blockedWithAutoAddUncIds.includes(selectedElem.id)

			setBlockAddUnc(blockedUncTable && originalObj.unc_auto_add)
		}
	}, [selectedElem])

	const handlerAddUnc = (uncCellId: string, interpolation: number, active: number) => {
		if (blockAddUnc) {
			dispatch(
				showNotify({
					type: 'warning',
					message: `Расценка не добавлена, т.к. включен режим авторасстановки ПИР, Б1-С1`,
				})
			)
			return
		}

		if (solutionCase && uncCellId) {
			dispatch(setSolutionObj({ uncCellId: Number(uncCellId) }))
			dispatch(setAdminUncsModalState({ linkOpen: false, editOpen: false }))
			dispatch(selectTableElem(null))
			if (isAdminUncsModalState.linkOpen && !isAdminUncsModalState.editOpen) {
				dispatch(
					editSolution(
						{
							id: solutionObj?.data?.id,
							techParamName: solutionObj?.data?.techParamName,
							uncCellId: Number(uncCellId),
						},
						10 // компания юзера должна быть
					)
				)
			}
		} else {
			if (uncCellId && !interpolation && active && uncCheckedTable == 6) {
				dispatch(addUnc(1, uncCellId, 0, true))
			} else if (uncCellId && !interpolation && active) {
				dispatch(addUnc(uncCheckedTable, uncCellId, 0, true))
			}
		}
	}

	const confirmHandler = () => {
		const clone = Object.assign({}, interpolation)

		Object.keys(interpolation).forEach(key => {
			if (clone[key] === 'deleted') {
				delete clone[key]
			}
		})
		selectedElem &&
			dispatch(createSpecialUnc(selectedElem.id, originalObj.regionIds[0], clone, String(uncCheckedTable)))
	}

	useEffect(() => {
		if (selectedElem && selectedElem.code.toLowerCase() === 'с1') {
			dispatch(changeUncCheckedTable(8))
			setChecked('8')
		}
	}, [selectedElem])

	return (
		<div className={`main_table ${selectedElem ? 'main_table__show' : ''} ${solutionCase ? 'admin_side_open' : ''}`}>
			<div className='pannel_header'>
				<div className='pannel__nav'>
					<Button
						onClick={() => {
							dispatch(selectTableElem(null))

							dispatch(fetchUncTableData(null, '2024'))
							if (uncCheckedTable === 8) {
								dispatch(changeUncCheckedTable(1))
								setChecked('1')
							}
						}}
						className='pannel__nav-btn'
					>
						Назад
					</Button>
				</div>
				{selectedElem && (
					<>
						<div className='pannel_header-wrapper'>
							<div className='title'>
								<div>
									<span className='table_num'>{`Таблица ${selectedElem.code}. `}</span>
									{selectedElem.name}
								</div>
							</div>
							<div>
								<div className='subtitle'>{`Измеритель: ${selectedElem.unit}`}</div>
								<div onClick={() => setShowDirections(true)} className='note_btn'>
									<p>Указания</p>
								</div>
							</div>
						</div>
						<SelectTableHeader
							setChecked={setChecked}
							checkedTable={uncCheckedTable}
							tableNums={tableNums}
							tableTitles={tableTitles}
							selectedElem={selectedElem}
							uncTableData={uncTableData}
							setShowInter={setShowInter}
							showInter={showInter}
							createSpecialUnc={confirmHandler}
						/>
					</>
				)}
			</div>
			<div className='table_wrapper table_wrapper-add_table'>
				<table className='add_table'>
					<SelectTableThead uncTableData={uncTableData} />
					<SelectTableTbody handlerAddUnc={handlerAddUnc} uncTableData={uncTableData} blockAddUnc={blockAddUnc} />
				</table>
			</div>
		</div>
	)
}
